export const API_VERSION = "v1.0";
let HOST_URL = window.location.host
let backend_url = ''
if (HOST_URL == 'www.epixcinemas.com') {
  backend_url = 'https://api.epixcinemas.com'
}
else if (HOST_URL == 'epixcinemas.com') {
  backend_url =  'https://api.epixcinemas.com'
}
else {
  backend_url = 'localhost'
}
export const BASEURL_BRIJ = backend_url

//const HOST_URL = `xanadu-mycinema.brij.tech`;
//const LIVEBASEURL = `https://xanadu-api.brij.tech`;
const DEVBASEURL = `http://localhost:3800`;
// const DEVBASEURL = `https://cinematic-server-gdc-3.brij.tech`;
// const DEVBASEURL = `http://shringar.brij.tech:3950`;
export const BASEURL = backend_url;
//  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL;
export const IMG_BASEURL = `https://api.epixcinemas.com`;
export const EPIX_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjU4ZDJlZTM4LTI4MDctNDQ4My05YzVhLThhZDYxMjI2OGY0MSIsImlhdCI6MTcwMzgzNTMzNn0.3eAPpdCzFTsGuHbgeJFCZknPbWS0WjDD1aSnNy_HRTk`;
export const TOKEN = EPIX_TOKEN;
